import { Reveal, MaskLine } from "./Reveal";

export const FinalCTA = () => {
  return (
    <section
      data-testid="final-cta-section"
      className="relative overflow-hidden px-6 py-32 md:py-44"
    >
      {/* Glow */}
      <div
        className="pointer-events-none absolute left-1/2 top-1/2 h-[420px] w-[420px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#2a1f4a] opacity-50 blur-[140px] breathe"
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute left-1/2 top-1/2 h-[300px] w-[300px] -translate-x-1/2 -translate-y-1/2 rounded-full border border-[#c9a84c]/10 breathe"
        aria-hidden="true"
      />

      <div className="relative z-10 mx-auto max-w-2xl text-center">
        <Reveal>
          <p className="mb-8 text-xs font-semibold uppercase tracking-[0.4em] text-[#c9a84c]">
            Ce soir, tu commences
          </p>
        </Reveal>
        <h2 className="text-6xl font-light leading-[1.02] tracking-tighter sm:text-7xl md:text-8xl">
          <MaskLine>Commence</MaskLine>
          <MaskLine delay={0.12} className="text-gold-gradient italic">
            ce soir.
          </MaskLine>
        </h2>
        <Reveal delay={0.2}>
          <p className="mx-auto mt-8 max-w-md text-lg leading-relaxed text-white/60">
            Vingt-et-une nuits pour retrouver des soirées calmes et un sommeil
            qui répare vraiment.
          </p>
          <button
            data-testid="final-cta-button"
            onClick={() =>
              document.querySelector("#pricing")?.scrollIntoView({ behavior: "smooth" })
            }
            className="group mt-11 inline-flex items-center gap-2 rounded-full bg-[#c9a84c] px-9 py-4 text-sm font-semibold text-[#0a0e1a] transition-colors duration-300 hover:bg-[#e8c97a] active:scale-[0.98]"
          >
            Rejoindre NUIT CALME
            <span className="transition-transform duration-300 group-hover:translate-x-1">
              →
            </span>
          </button>
        </Reveal>
      </div>
    </section>
  );
};
